<template>
    <div>
        <div v-if="hideCarousel" class="image-cover" :style="bgImageStyle" @click="hideCarousel = false"></div>
        <vcarousel :style="`max-height: ${height}; overflow: hidden`" v-else :data="data" :indicators="showIndicators && this.images.length > 1" :autoplay="autoplay" indicator-type="disc"></vcarousel>
    </div>
</template>

<script>
export default {
  name: 'SmallCarousel',
  props: {
    images: {
      type: Array,
      default: () => []
    },
    showIndicators: {
      type: Boolean,
      default: true
    },
    height: {
      type: String,
      default: '200px'
    },
    autoplay: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hideCarousel: true,
      data: this.images.map(image => {
        return `<div class="slide image-cover" :style="\`background-image: url(${image})\`"></div>`
      })
    }
  },
  computed: {
    bgImageStyle () {
      if (!this.images) return ''
      return `background-image: url(${this.images[0]}); height: ${this.height}; cursor: pointer`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/widgets/common/SmallCarousel.vue